var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.15244 28.0318L3.96777 23.8464L23.8471 3.96777L28.0318 8.15311L8.15244 28.0318Z",
    fill: "#F55376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.1851 15.9998L15.9998 20.1851L23.8471 28.0318L28.0318 23.8464L20.1851 15.9998ZM8.15244 3.96777L3.96777 8.15311L11.8144 15.9998L15.9998 11.8144L8.15244 3.96777Z",
    fill: "#F55376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9998 11.8145L11.8145 15.9998L15.9998 20.1851L20.1851 15.9998L15.9998 11.8145Z",
    fill: "#EB0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.28723ec789236ae0db098c189c72b55e.svg";
export { ForwardRef as ReactComponent };